import { render, staticRenderFns } from "./weixinMenu.vue?vue&type=template&id=1517060a&scoped=true&"
import script from "./weixinMenu.vue?vue&type=script&lang=js&"
export * from "./weixinMenu.vue?vue&type=script&lang=js&"
import style0 from "./weixinMenu.vue?vue&type=style&index=0&id=1517060a&lang=less&scoped=scoped&"
import style1 from "./weixinMenu.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1517060a",
  null
  
)

export default component.exports